import React from 'react';
import { ArrowRight, CheckCircle, Play } from 'lucide-react';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-green-600 to-emerald-700 dark:from-green-700 dark:to-emerald-900 relative overflow-hidden">
      {/* 배경 패턴 */}
      <div className="absolute inset-0 bg-pattern opacity-10"></div>

      {/* 플로팅 요소들 */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-white/10 rounded-full blur-xl animate-pulse delay-1000"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* 메인 헤딩 */}
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">지금 바로 스마트팜을 시작하세요</h2>

          <p className="text-xl text-green-100 mb-8 max-w-3xl mx-auto">
            30일 무료 체험으로 IFMS의 모든 기능을 경험해보세요. 바로 시작할 수 있습니다.
          </p>

          {/* 혜택 리스트 */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            {['30일 무료 체험', '신용카드 등록 불필요', '언제든 취소 가능'].map((benefit, index) => (
              <div key={index} className="flex items-center gap-2 text-white">
                <CheckCircle className="w-5 h-5 text-green-200" />
                <span className="font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTA 버튼들 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button className="group px-8 py-4 bg-white text-green-600 font-bold rounded-lg shadow-xl hover:shadow-2xl transition-all duration-200 transform hover:-translate-y-1 flex items-center gap-2">
              무료로 시작하기
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>

            <button className="group px-8 py-4 bg-green-700/50 backdrop-blur-sm text-white font-bold rounded-lg border-2 border-white/30 hover:bg-green-700/70 transition-all duration-200 flex items-center gap-2">
              <Play className="w-5 h-5" />
              데모 영상 보기
            </button>
          </div>

          {/* 추가 정보 */}
          <p className="mt-8 text-green-100 text-sm">
            이미 <span className="font-bold text-white">500+</span> 농장이 IFMS와 함께하고 있습니다
          </p>
        </div>
      </div>
    </section>
  );
}
